import React from 'react';
import dayjs from 'dayjs'
import Navigation from './navigation';
import Avatar from 'react-avatar';

export default class ContestDetail extends React.Component {

    state = {
        pageState: 'normal',
        comment: '',
    }

    componentDidMount() {
        if (this.props.account === null) {
            this.props.getAccount();
        }
        if (this.props.ideas === null) {
            this.props.getIdeas();
        }
    }

    postComment(idea) {
        const { comment } = this.state;
        if (comment !== '') {
            this.props.postComment({
                idea: 'idea',
                id: idea._id,
                comment: this.state.comment,
                type: 'idea',
            });
            this.setState({ comment: '' });
            setTimeout(() => {
                window.scrollTo({
                    top: document.body.scrollHeight,
                    left: 0,
                    behavior: 'smooth',
                });
            }, 400);
        }
    }

    render() {
        const { comment } = this.state;
        const { id } = this.props.match.params;
        const { ideas, account } = this.props;
        const idea = ideas !== null && ideas.length > 0 ? this.props.ideas.find(idea => idea._id === id) : {};
        const featuredImage = Boolean(idea.featureImgUrl) ? idea.featureImgUrl : require('../assets/bg-1.jpg');
        return (
            <div>
                {Boolean(idea) &&
                    <div>
                        <Navigation {...this.props} />
                        <div
                            className="px-8 py-12 relative"
                            style={{ backgroundSize:'cover', backgroundPosition:'center', backgroundImage: `url(${featuredImage})` }}>
                            <div className="bg-gradient-black-to-transparent"></div>
                            <h2 className="relative text-center text-4xl lg:text-6xl text-white font-bold">{idea.title}</h2>
                        </div>
                        <div className="min-h-screen bg-gray-200 p-4">
                            {Boolean(idea.content) &&
                                <div className="max-w-3xl mx-auto">
                                    <div className="mb-8 text-lg">{idea.content}</div>
                                    <p className="text-sm text-gray-700 font-bold">Comments ({idea.comments.length}) | Likes ({idea.likes.length})</p>
                                    <textarea
                                        value={comment}
                                        className="mb-4 mt-6 bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal"
                                        onChange={e => this.setState({ comment: e.target.value })}>
                                    </textarea>
                                    <button 
                                        className="p-4 bg-west-green hover:bg-west-green-400 hover:bg-west-green-400 items-center text-white leading-none rounded-full inline-flex"
                                        onClick={() => this.postComment(idea)}>Post comment</button>
                                    {idea.comments.map(comment => (
                                        <div key={comment._id}>
                                            <div className="mb-2 mt-6 bg-gray-300 focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal">
                                                {comment.content}
                                            </div>
                                            <div className="text-gray-700 text-sm pl-4">
                                                <div className="flex flex-wrap">
                                                    <Avatar className="mr-4" size="50px" color="#80c7bc" round={true} name={`${comment.user.firstName} ${comment.user.lastName}`} />
                                                    <div>
                                                        <div className="font-bold text-gray-900">{Boolean(comment.user.firstName) ? `${comment.user.firstName} ${comment.user.lastName}` : 'Coworker'}</div>
                                                        <p className="text-sm text-gray-700">{dayjs(comment.createdAt).format('MMM DD, YYYY h:mma')}</p>
                                                        {comment.user._id === account._id &&
                                                            <div className="text-xs cursor-pointer text-red-600 font-semibold" onClick={() => this.props.deleteComment({
                                                                type: 'idea',
                                                                commentId: comment._id,
                                                                contentId: idea._id,
                                                            })}>Delete comment</div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/idea-detail.js